function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}
class PredictiveSearch extends HTMLElement {
    constructor() {
        super();
        this.cachedResults = {};
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('[data-predictive-search-results]');
        this.predictiveSearchSuggestion = this.querySelector('[data-predictive-search-suggestion]');
        this.predictiveSearchSuggestionList = this.querySelector('[data-predictive-search-suggestion-list]');
        this.setupEventListeners();
    }

    setupEventListeners() {
        this.input.addEventListener('input', debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
    }

    getQuery() {
        return this.input.value.trim();
    }

    onChange() {
        const searchTerm = this.getQuery();
        if (!searchTerm.length) {
            this.close(true);
            return;
        }
        this.getSearchResults(searchTerm);
        this.renderSuggestion(searchTerm);
    }

    getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(" ", "-").toLowerCase();
        if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            return;
        }
        fetch(`${ window.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,query&${encodeURIComponent('resources[limit]')}=6&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    throw error;
                    this.close();
                }
                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').querySelector('#predictive-search-results').innerHTML;
                if(resultsMarkup.length > 0){
                    this.cachedResults[queryKey] = resultsMarkup;
                    this.renderSearchResults(resultsMarkup);
                }else{
                    this.close();
                }
            })
            .catch((error) => {
                throw error;
            });
    }

    renderSearchResults(resultsMarkup) {
        if(resultsMarkup.trim().length > 0) {
            this.predictiveSearchResults.innerHTML = resultsMarkup;
            if(window.lazyLoadEnabled == "true"){
                reloadLazyLoad();
            }
            this.open();
        }
    }
    open() {
        document.querySelector('body').classList.add('no-scroll');
        if(document.querySelector('.header-search__modal')){
            document.querySelector('.header-search__modal').classList.add('show');
        }
    }

    close(clearSearchTerm = false) {
        if (clearSearchTerm) {
            this.input.value = '';
            this.removeAttribute('results');
        }
        document.querySelector('body').classList.remove('no-scroll');
        if(document.querySelector('.header-search__modal')){
            document.querySelector('.header-search__modal').classList.remove('show');
        }
    }
    renderSuggestion(searchTerm){
        let term = searchTerm.replace(" ", "-").toUpperCase();
        let searchList = this.predictiveSearchSuggestionList.querySelectorAll('li');
        let showSuggestion = false
        searchList.forEach(item => {
            let value = item.dataset.value;
            let index = value.replace(" ", "-").toUpperCase().search(term)
            let link = item.querySelector('a');
            if (value.replace(" ", "-").toUpperCase().search(term) >= 0 ) {
                item.style.display = 'list-item';
                link.innerHTML = value.substring(0,index) + "<b>" + value.substring(index,index+term.length) + "</b>" + value.substring(index + term.length);
                showSuggestion = true
            } else {
                item.style.display = 'none';
            }
            if(showSuggestion){
                this.predictiveSearchSuggestion.classList.remove('hidden')
            }else{
                this.predictiveSearchSuggestion.classList.add('hidden')
            }
        })
    }
}
customElements.define('predictive-search', PredictiveSearch);
